import store from "../../store";
import useProduct from "./useProduct";

export default function usePhoto() {
  const { updateProductAttributeValue } = useProduct();

  // [CUSTOM]
  function updatedPhotoStyle(index) {
    const type =
      store.getters["product/getAttributes"]["photoStyle"].attribute_values[
        index
      ];
    let product = store.getters["product/getProduct"];

    updateProductAttributeValue("photoStyle", type);
    // for editing - preset index
    type.index = index;
    product.attribute_values["photoStyle"] = type;

    store.commit("product/SET_PRODUCT", product);
  }

  return {
    // methods
    updatedPhotoStyle,
  };
}
